<template>
  <div class="diamond">
    <div class="head">绝地武士定制系列</div>
    <ul>
      <li v-for="(item,index) in list" :key="index">
        <div class="right">
          <label for>
            <img :src="item.img[0]" alt />
          </label>

          <div>
            <p class="title">{{item.title}}</p>
            <span
              class="more"
              @click="$router.push({path:'/diamond/detail',query:{id:item.id}})"
            >查看详细介绍</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="btn" @click="more">加载更多</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: this.$route.path == "/diamond" ? 0 : 1,
      page: 1,
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    more() {
      this.page = this.page + 1;
      this.getList();
    },
    getList() {
      this.axios
        .post("product/index", {
          category_id: 4,
          per_page: 8,
          page: this.page
        })
        .then(r => {
          this.list = this.list.concat([...r.data]);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.diamond {
  padding-top: 0.2rem;
}
ul {
  margin: 0 auto;
  margin-top: 1.3rem;
  width: 12rem;
  display: flex;
  flex-wrap: wrap;
  li:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    img {
      transform: scale(1.1, 1.1);
    }
  }
  li {
    width: 25%;
    box-sizing: border-box;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 0.2rem;
    font-family: "FZShuSong-Z01T";
    transition: all 0.3s linear;
    div {
      user-select: none;
      & > label {
        display: block;
        width: 100%;
        height: 2rem;
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 2rem;
        transition: all 0.3s linear;
        object-fit: cover;
        vertical-align: top;
      }

      div {
        flex-direction: column;
        width: 100%;
        display: flex;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        background: #f7f7f7;
        .title {
          font-size: 0.2rem;
        }
        .no {
          font-size: 0.16rem;
          font-family: "Baskerville Old Face";
          margin-top: 0.11rem;
          margin-bottom: 10px;
        }
        .desc {
          font-size: 0.14rem;
       line-height: 24px;
          margin-bottom: 10px;
        }
        .more {
          font-size: 0.14rem;
          padding: 0.05rem;
          border-bottom: 1px solid rgba(33, 33, 33, 1);
          cursor: pointer;
          width: 90px;
          transition: all 0.3s linear;
          margin-top: 20px;
        }
        .more:hover {
          opacity: 0.5;
          border-bottom: 1px solid rgba(33, 33, 33, 1);
          padding: 0.05rem 0;
        }
      }
    }
  }
}
.btn {
  width: 3.29rem;
  height: 0.59rem;
  background: rgba(0, 0, 0, 1);
  margin: 0.9rem auto 0;
  cursor: pointer;
  text-align: center;
  line-height: 0.59rem;
  color: white;
  font-size: 0.16rem;
  font-family: FZShuSong-Z01T;
  transition: all 0.3s linear;
  user-select: none;
}
.btn:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
.btn:active {
  opacity: 0.58;
}
@media (max-width: 767px) {
  ul {
    margin-top: 30px;
    width: 100%;
    li {
      width: 100%;
      margin-bottom: 20px;
      padding: 10px;
      box-sizing: border-box;
      background: rgb(251, 251, 251);
      margin: 20px 0;
      div {
        display: block;
        img {
          width: 100%;
          height: auto;
        }
        div {
          width: 100%;
          .title {
            font-size: 16px;
          }
          .no {
            font-size: 12px;
          }
          .desc {
            font-size: 14px;
            line-height: 20px;
          }
          .more {
            font-size: 12px;
            width: auto;
          }
        }
      }
    }
  }
  .btn {
    width: 50%;
    font-size: 14px;
    padding: 10px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/spinel.vue